import { Routes } from '@angular/router';
import { AppRootComponent } from '@core/components/app-root/app-root.component';
import { RouterComponent } from 'common';

export const AppSkeletonRoutes: Routes = [
  {
    path: '',
    component: AppRootComponent,
    children: [
      {
        path: '',
        component: RouterComponent,
        data: { title: '' },
        loadChildren: () => import('@public-site/main/main.module').then(m => m.MainModule),
      },
      {
        path: 'event',
        component: RouterComponent,
        data: { title: 'general_lang_programs' },
        loadChildren: () => import('@modules/event/event.module').then(m => m.EventModule),
      },
      {
        path: 'cart',
        component: RouterComponent,
        data: { title: 'stemx_boxoffice_refund_cart' },
        loadChildren: () => import('@modules/cart/cart.module').then(m => m.CartModule),
      },
      {
        path: 'card',
        component: RouterComponent,
        data: { title: 'stemx_card_type_giftcard', home: true },
        loadChildren: () => import('@modules/card/card.module').then(m => m.CardModule),
      },
      {
        path: 'contact',
        component: RouterComponent,
        data: { title: 'label_contact' },
        loadChildren: () => import('@public-site/misc/misc.module').then(m => m.MiscModule),
      },
    ],
  },
];
